<div class="homepage">
  <div class="wrapper" id="top">
    <div class="page">

      <div class="grid-x align-center">

        <mat-card>
          <mat-card-content>

            Se está confirmando tu clave...

          </mat-card-content>
        </mat-card>

      </div>
      <p style="height: 282px;"></p>
    </div>

  </div>
</div>